import { Injectable } from '@angular/core';

@Injectable()
export class PrintTableService {
  print(selector: string): void  {
    let printContents, popupWin;
    printContents = document.getElementById(selector).innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>На печать</title>
            <style>
                table{
                  width: 100%;
                  border-spacing: 0 0;
                }
                td{
                  text-align: center;
                  min-width: 75px;
                  border: 1px solid black;
                }
            </style>
        </head>
    <body onload="window.print();window.close()">
        <h1>Отчеты по устройствам за период</h1>
        ${printContents}
    </body>
      </html>`
    );
    popupWin.document.close();
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/services/printTableService.ts